/* Virtual Games · sello de preventa. Muestra [data-vg-preventa] (ficha) y [data-vg-preventa-tarjeta] (tarjeta)
   solo si la fecha de lanzamiento es posterior a hoy en Chile. En la ficha sigue a la variante elegida. */
(function () {
  function hoy() {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago' }).format(new Date()); }
    catch (e) { return new Date().toISOString().slice(0, 10); }
  }
  function fmt(iso, corto) {
    var p = iso.split('-'), d = new Date(+p[0], +p[1] - 1, +p[2]);
    var o = corto ? { day: 'numeric', month: 'short' } : { day: 'numeric', month: 'long' };
    if (!corto && +p[0] !== +hoy().slice(0, 4)) o.year = 'numeric';
    var s = d.toLocaleDateString('es-CL', o);
    return corto ? s.replace('.', '') : s;
  }
  // La variante que se compra es la del formulario (Horizon la actualiza al cambiar de opción); la URL va de respaldo.
  function variante(el) {
    var scope = el.closest('product-info, .product-information, main') || document;
    var i = scope.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (i && i.value) return i.value;
    return new URLSearchParams(window.location.search).get('variant');
  }
  function pintar() {
    var h = hoy();
    var fichas = document.querySelectorAll('[data-vg-preventa]');
    for (var i = 0; i < fichas.length; i++) {
      var el = fichas[i], m;
      try { m = JSON.parse(el.getAttribute('data-vg-preventa')); } catch (e) { continue; }
      var vid = variante(el), f = (vid && m.v && m.v[vid]) || m.d || '';
      var on = !!f && f > h;
      el.hidden = !on;
      if (on) { var t = el.querySelector('[data-vg-preventa-fecha]'); if (t) t.textContent = fmt(f, false); }
    }
    var tarjetas = document.querySelectorAll('[data-vg-preventa-tarjeta]');
    for (var j = 0; j < tarjetas.length; j++) {
      var tj = tarjetas[j], ft = tj.getAttribute('data-vg-preventa-tarjeta');
      var ok = !!ft && ft > h;
      tj.hidden = !ok;
      if (ok) { var s = tj.querySelector('[data-vg-preventa-fecha]'); if (s) s.textContent = fmt(ft, true); }
    }
  }
  // Horizon actualiza el formulario y la URL en pasos: se repinta enseguida y de nuevo cuando termina.
  var t1, t2;
  function pronto() { clearTimeout(t1); clearTimeout(t2); t1 = setTimeout(pintar, 60); t2 = setTimeout(pintar, 700); }
  document.addEventListener('variant:update', pronto, true);
  document.addEventListener('input', function (e) { if (e.target && e.target.name === 'id') pronto(); }, true);
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker, [data-variant-picker], form')) pronto(); });
  window.addEventListener('popstate', pronto);
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var a = ms[i].addedNodes;
      for (var k = 0; k < a.length; k++) {
        var n = a[k];
        if (n.nodeType === 1 && ((n.matches && n.matches('[data-vg-preventa],[data-vg-preventa-tarjeta]')) || (n.querySelector && n.querySelector('[data-vg-preventa],[data-vg-preventa-tarjeta]')))) { pronto(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pintar); else pintar();
})();
